<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">{{ letter.buyProduct }}</template>
    <template slot="select-content">
      <List class="area-select-container j-product-select-container">
        <ListItem
          type="productSelectOptions"
          class="areas-lst select-items j-product-dcount"
          @click="selectProduct(product)"
          v-for="product in productList"
          :active="curProduct.PRODUCT_ID === product.PRODUCT_ID"
          :key="product.PRODUCT_ID"
        >
          {{ getProductName(product) }}
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import { getProductList } from '@store/officialStore/storager';
import product from '@mixins/product';
export default {
  mixins: [selectContainer, product],
  data() {
    let productList = getProductList();
    return {
      productList
    };
  },
  props: ['curProduct'],
  methods: {
    selectProduct(product) {
      this.$emit('select-product', product);
      this.close();
    }
  }
};
</script>
